import React, { FC, useState, useEffect, useContext } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import history from '../../../history'
import cookie from 'react-cookies'
import { generateChallengesStripeSession, getProductData } from '../../../Api/challengesApi'
import { useLocation } from 'react-router-dom'


import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import Exclaimation from '../../../assets/REDESIGN_Assets/SelectSubscriptionScreen/exclaimation-mark.svg'

import { PurchaseOptionBox } from '../style'

interface ChooseMiazgaVersionInterface { }

const ChooseMiazgaVersion: FC<ChooseMiazgaVersionInterface> = ({ }) => {

  const [productData, setProductData] = useState<any>()
  const location = useLocation()

  useEffect(() => {
    handleGetProduct()
  }, [])


  const handleGetProduct = async () => {

    const product: any = await getProductData(location.state && location.state.productId)

    setProductData(product && product.stripe_product)


  }

  const selectMiazga = () => {
    cookie.save('userSelectedMiazga', true, { path: '/' })
    history.replace({ pathname: "/redirect", state: { selectedMiazga: true } })
  }

  const selectChallenge = () => {
    cookie.save('userSelectedChallenge', true, { path: '/' })
    history.replace({ pathname: "/wyzwania", state: { selectedChallenge: true } })
  }


  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className="standard chose-ver "

    >
      <GenericRow margin="3% 0 0 0">
        <GenericLogo />
      </GenericRow>

      <GenericRow margin="3% 0 0 0">
        <GenericTextSpan fSize="2rem">
          Wybierz wersję MIAZGI odpowiednią dla Ciebie
        </GenericTextSpan>
      </GenericRow>
      <GenericRow margin="2% 0 0 0">
        <GenericTextSpan fSize="1rem">
          Możesz później w łatwy sposób zmienić wybór
        </GenericTextSpan>
      </GenericRow>



      <GenericRow className={`choose-miazga ${isTablet && "tablet-view"}`} flexDir={isMobile ? "column" : "row"} width={isMobile ? "90%" : "60%"} margin="3% 0 0 0" justify="space-between">

        <GenericColumn width={isMobile ? "100%" : "49%"}>
          <PurchaseOptionBox className={`select-option ${isTablet && "tablet-view"}`}>
            <div>
              <GenericRow>
                <GenericColumn width="50%">
                  <GenericTextSpan tAlign="left" width="100%" fSize="2rem">Wersja PEŁNA</GenericTextSpan>
                </GenericColumn>
                <GenericColumn width="50%">
                  <GenericRow justify="flex-end">
                    <GenericTextSpan color="#a1ff68" fSize="1.2rem" tAlign="right">zł</GenericTextSpan>
                  </GenericRow>
                  <GenericRow justify="flex-end" align="baseline">
                    <GenericTextSpan margin="0 10% 0 0">od</GenericTextSpan>
                    <GenericTextSpan color="#a1ff68" fSize="4rem" tAlign="right">69,99</GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
              </GenericRow>




              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Program treningowy Miazga - ponad 300 treningów, od poziomu początkującego do zaawansowanego, wraz z programem dla osób skrajnie otyłych oraz osób z dużą nadwagą
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="1.5% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Dodatki extra - ponad 400 treningów w działach: aeroboks, pilates, joga, taniec, także treningi dla osób starszych
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Dział TECHNIKA - ustrzeż się przed kontuzjami, zwiększ efektywność swojej pracy
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Pełny panel DIETY - wyliczymy Twoje zapotrzebowanie kaloryczne a Ty dobierzesz dietę odpowiednią dla siebie
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Porady ekspertów - fizjoterapeuta, kosmetolog, seksuolog, stylistka
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Dział „kuchnia”, czyli proste gotowanie - kuchnia keto, vege oraz zdrowe posiłki w 15 minut
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Treningi wspólne - ćwicz z koleżankami online
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin="3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Zakup w subskrypcji.
                </GenericTextSpan>
              </GenericRow>
            </div>
            <div>
              <GenericRow width="100%" margin="3% 0 0 0" justify="center">
                <GenericButton onClick={() => selectMiazga()} width="70%" justify="center" className="standard">Wybierz</GenericButton>
              </GenericRow>
            </div>
          </PurchaseOptionBox>

        </GenericColumn>

        <GenericColumn width={isMobile ? "100%" : "49%"}>
          <PurchaseOptionBox className={`select-option ${isTablet && "tablet-view"}`}>
            <div>
              <GenericRow>
                <GenericColumn width="50%">
                  <GenericTextSpan width="100%" tAlign="left" fSize="2rem">Wyzwania</GenericTextSpan>
                </GenericColumn>
                <GenericColumn width="50%">
                  <GenericRow justify="flex-end">
                    <GenericTextSpan color="#a1ff68" fSize="1.2rem" tAlign="right">zł</GenericTextSpan>
                  </GenericRow>
                  <GenericRow justify="flex-end" align="baseline">
                    {/* <GenericTextSpan margin="0 10% 0 0">od</GenericTextSpan> */}
                    <GenericTextSpan color="#a1ff68" fSize="4rem" tAlign="right"> 59,99</GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
              </GenericRow>

              <GenericRow margin="10% 0 3% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Zestawy wyselekcjonowanych treningów miazgowych na konkretne partie ciała.
                </GenericTextSpan>
              </GenericRow>
              <GenericRow margin="4% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Panel DIETA - gratis ( wyliczymy Twoje zapotrzebowanie kaloryczne a Ty dobierzesz dietę odpowiednią dla siebie) - skorzystaj i przyspiesz efekty
                </GenericTextSpan>
              </GenericRow>
              <GenericRow margin="4% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Dział TECHNIKA - gratis - poprawna technika chroni przed kontuzją i zwiększa efektywność pracy
                </GenericTextSpan>
              </GenericRow>
              <GenericRow margin="4% 0" align="center" justify="flex-start">
                <GenericIcon margin="0 10px 0 0" src={Exclaimation} width="14px" height="14px" />
                <GenericTextSpan width="80%" tAlign="left" fSize="1.1rem">
                  Zakup jednorazowy z dostępem na 1 miesiąc.
                </GenericTextSpan>
              </GenericRow>
            </div>

            <div>
              <GenericRow width="100%" margin="3% 0 0 0" justify="center">
                <GenericButton onClick={() => selectChallenge()} width="70%" justify="center" className="standard">Wybierz</GenericButton>
              </GenericRow>
            </div>



          </PurchaseOptionBox>

        </GenericColumn>
      </GenericRow>

    </GenericBackgroundLayer >
  )
}






export default ChooseMiazgaVersion
